import Vuetable from 'vuetable-2-ashfari';
import VuetablePagination from "vuetable-2-ashfari/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2-ashfari/src/components/VuetablePaginationInfo";
import PaginationPerPage from "../components/PaginationPerPage";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PaginationPerPage,
    },

    data() {
        return {
            perPage: 10,
            css: {
                table: {
                    tableWrapper: '',
                    tableHeaderClass: 'mb-0 align-middle',
                    tableBodyClass: 'mb-0',
                    tableClass: 'table table-hover border-top',
                    loadingClass: 'loading',
                    ascendingIcon: 'fas fa-sort-up pt-1',
                    descendingIcon: 'fas fa-sort-down pt-2',
                    ascendingClass: '',
                    descendingClass: '',
                    sortableIcon: 'fas fa-sort pt-1',
                    detailRowClass: 'vuetable-detail-row',
                    handleIcon: 'fas fa-bars text-secondary',
                },
                pagination: {
                    wrapperClass: 'pagination pt-1',
                    activeClass: 'active disabled text-secondary',
                    disabledClass: 'disabled',
                    pageClass: 'btn btn-link no-decoration px-2',
                    linkClass: 'btn btn-link no-decoration px-2',
                    paginationClass: 'pagination',
                    paginationInfoClass: 'float-left',
                    dropdownClass: 'form-control',
                    icons: {
                        first: 'fas fa-angle-double-left',
                        prev: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        last: 'fas fa-angle-double-right',
                    }
                },
                paginationInfo: {
                    infoClass: 'left floated left aligned six wide column pt-3',
                }
            },
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
    },

    methods: {
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },

        onChangePerPage(value) {
            this.perPage = value;
            this.refresh();
        },

        refresh() {
            this.$nextTick(() => {
                this.$refs.vuetable.refresh();
            });
        },
    },
}
